import request from '@/util/http';

export default {
  devicelist,           //设备列表
  addorupdatedevice,    //添加或者修改设备
  userlist,             //下拉框时获取用户列表
  devicepartslist,      //设备零件列表
  deviceaddparts,       //添加设备零件
  deleteparts,          //删除零件
  orgList,              //架构列表
  wxList,               //获取维修组信息
  exportWx,             //导出维修单
  exportfaultrateddata, //故障率分析导出
}
function exportfaultrateddata(data) {
  return request({
    url: "excel/api/exportfaultrateddata",
    method: 'post',
    responseType:'blob',
    data
  })
}

function devicelist(data) {
  return request({
    url: "sys/api/devicelist",
    method: 'post',
    data
  })
}

function addorupdatedevice(data) {
  return request({
    url: "sys/api/addorupdatedevice",
    method: 'post',
    data
  })
}

function userlist(data) {
  return request({
    url: "sys/api/userlist",
    method: 'post',
    data
  })
}

function devicepartslist(data) {
  return request({
    url: "device/api/devicepartslist",
    method: 'post',
    data
  })
}

function deviceaddparts(data) {
  return request({
    url: "sys/api/deviceaddparts",
    method: 'post',
    data
  })
}

function deleteparts(data) {
  return request({
    url: "sys/api/deleteparts",
    method: 'post',
    data
  })
}

function orgList(data) {
  return request({
    url: "org/api/orglist",
    method: 'post',
    data
  })
}

function wxList(data) {
  return request({
    url: "/device/api/devicewxlist",
    method: 'post',
    data
  })
}

function exportWx(data) {
  return request({
    url: "/excel/api/exportwxddata",
    method: 'post',
    responseType:'blob',
    data
  })
}